// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScrollToTop_wrapper__31IXC","button":"ScrollToTop_button__3rGQL"};